import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

/**
 * Shown when a Stripe Checkout session is cancelled (user clicks Back on
 * the Stripe page). No order is ever created in this path — by design.
 */
export default function PaymentCancelled() {
  const [params] = useSearchParams();
  const draftId = params.get("draft");

  return (
    <div className="tk-container py-24 max-w-xl text-center" data-testid="payment-cancelled-page">
      <XCircle className="mx-auto mb-6 text-amber-500" size={56} />
      <h1 className="text-3xl font-semibold mb-2" data-testid="cancelled-title">
        Betalingen ble ikke fullført
      </h1>
      <p className="text-slate-500 mb-2">
        Bestillingen er <span className="font-medium">ikke opprettet</span> — du har ikke blitt belastet.
      </p>
      <p className="text-slate-500 mb-8">
        Prøv igjen eller kontakt oss på{" "}
        <a href="mailto:post@tekkdeler.no" className="underline" data-testid="cancelled-support-email">
          post@tekkdeler.no
        </a>
        .
      </p>
      <div className="flex flex-wrap gap-3 justify-center">
        {draftId && (
          <Link
            to={`/kassen?draft=${draftId}`}
            className="tk-btn-primary"
            data-testid="cancelled-retry-btn"
          >
            Prøv igjen
          </Link>
        )}
        <Link to="/butikk" className="tk-btn-secondary" data-testid="cancelled-back-shop-btn">
          Tilbake til butikken
        </Link>
      </div>
    </div>
  );
}
